import { DISABILITY_DISCOUNT_CODE_ACC_LEVEL } from "../constants";

// Stub for a legacy BE check: they can't fix/remove it on the post-logout callback step, so this function must stay.
export function removeDDiscountCode(couponCodes: string[]): string[] {
  return couponCodes.filter(
    (code) => code !== DISABILITY_DISCOUNT_CODE_ACC_LEVEL
  );
}
